import { FlexRow } from '@guryou/html-components';
import { cognitoLogout } from '@guryou/redux';
import { colors } from '@guryou/colors';
import AppDownloadSuccess from 'modules/verify/AppDownloadOnSuccess';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const SuccessPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const appConfig = location.state?.appConfig;

  useEffect(() => {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('CognitoIdentityServiceProvider')) {
        localStorage.removeItem(key);
      }
    });
    dispatch(cognitoLogout());
  }, [dispatch]);

  return (
    <FlexRow xs={12} alignItems="flex-start" minHeight="100%" paddingTop="4vh" paddingBottom="4vh" backgroundColor={colors.mineShaft} margin={0}>
      <AppDownloadSuccess appConfig={appConfig} />
    </FlexRow>
  );
};

export default SuccessPage;
